import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/query/react";
import {
    fetchAllVehicles,
    fetchAllServiceHistories,
    addVehicle,
    addServiceHistory,
    signUp,
    signIn,
    googleLogin,
    updateVehicle,
    deleteVehicle,
    updateServiceHistory,
    deleteServiceHistory,
    updateProfile,
    deleteAccount,
    fetchNotifications,
    fetchHeaderNotifications,
    markNotificationRead,
    markAllNotificationsRead,
    forgotPassword,
    resetPassword,
    contactUs,
} from "./apis";

export default (builder: EndpointBuilder<
    BaseQueryFn<any, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
    never,
    'baseApi'
>) => {
    return {
        fetchAllVehicles: fetchAllVehicles(builder),
        fetchAllServiceHistories: fetchAllServiceHistories(builder),
        addServiceHistory: addServiceHistory(builder),
        addVehicle: addVehicle(builder),
        signUp: signUp(builder),
        signIn: signIn(builder),
        googleLogin: googleLogin(builder),
        updateVehicle: updateVehicle(builder),
        deleteVehicle: deleteVehicle(builder),
        updateServiceHistory: updateServiceHistory(builder),
        deleteServiceHistory: deleteServiceHistory(builder),
        updateProfile: updateProfile(builder),
        deleteAccount: deleteAccount(builder),
        fetchNotifications: fetchNotifications(builder),
        fetchHeaderNotifications: fetchHeaderNotifications(builder),
        markNotificationRead: markNotificationRead(builder),
        markAllNotificationsRead: markAllNotificationsRead(builder),
        forgotPassword: forgotPassword(builder),
        resetPassword: resetPassword(builder),
        contactUs: contactUs(builder),
    };
}
